import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ProtectedTabs from './layouts/ProtectedTabs';
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { RecentPagesProvider } from './context/RecentPagesContext';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/global.css';
import './theme/theme.css';

setupIonicReact();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App: React.FC = () => {
  // eslint-disable-next-line no-console
  console.log('[Admin Mobile] App bootstrap', window.location.href);

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <ThemeProvider>
          <NotificationProvider>
            <RecentPagesProvider>
              <AuthProvider>
                <IonApp>
                  <IonReactRouter>
                    <IonRouterOutlet>
                      <Switch>
                        <Route exact path="/login" component={Login} />
                        <Route path="/tabs" component={ProtectedTabs} />
                        <Route exact path="/">
                          <Redirect to="/login" />
                        </Route>
                        <Route>
                          <Redirect to="/login" />
                        </Route>
                      </Switch>
                    </IonRouterOutlet>
                  </IonReactRouter>
                </IonApp>
              </AuthProvider>
            </RecentPagesProvider>
          </NotificationProvider>
        </ThemeProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
};

export default App;
